import React, { useEffect, useState } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import FilterComponent from './FilterComponent';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Box from '@mui/material/Box';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DonorReceiverFilter = ({ value, options, handleDonorReceiverChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [listValue, setListValue] = useState(value);

  useEffect(() => {
    handleDonorReceiverChange(listValue);
  }, [listValue]);

  const getLabel = selectedValues => {
    const selectedUniqueValuesList = [...new Set(selectedValues.map(r => r.title))];
    // filter selected values by available options (truncate values out of the list)
    const filteredSelectedValues = options.filter(option => selectedUniqueValuesList.includes(option.title));

    const selectedOptions = filteredSelectedValues.length;
    if (selectedOptions === 0 || selectedOptions === options.length) {
      return 'Donor/Receiving Agency: all';
    }

    return `Donor/Receiving Agency: ${selectedOptions} selected`;
  };

  return (
    <>
      <ListItem button onClick={() => setIsOpen(!isOpen)}>
        <ListItemText primary={getLabel(listValue)} />
        {isOpen ? <ExpandMore /> : <ExpandLess />}
      </ListItem>
      <FilterComponent isOpen={isOpen}>
        <Box flexGrow={1} display="flex" flexDirection="column">
          <Autocomplete
            open
            onClose={() => {}}
            value={listValue}
            onChange={(event, newValue) => setListValue(newValue)}
            multiple
            sx={{
              width: '100%',
              padding: '5px 15px',
            }}
            slotProps={{
              paper: {
                sx: {
                  boxShadow: 'none',
                  margin: 0,
                  color: '#586069',
                  fontSize: 13,
                  width: '100%',
                  transform: 'none',
                },
              },
              popper: {
                disablePortal: true,
                sx: {
                  position: 'relative !important',
                  width: '100% !important',
                  transform: 'none !important',
                  inset: 'unset !important',
                  zIndex: 2,
                },
              },
            }}
            disableCloseOnSelect
            disablePortal
            renderTags={() => null}
            noOptionsText="No labels"
            isOptionEqualToValue={(option, value) => option.title === value.title}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  color="secondary"
                  checked={selected}
                />
                {option.title}
              </li>
            )}
            options={options}
            groupBy={option => option.groupName}
            getOptionLabel={option => option.title}
            renderInput={params => (
              <TextField
                variant="outlined"
                fullWidth
                ref={params.InputProps.ref}
                inputProps={params.inputProps}
              />
            )}
          />
        </Box>
      </FilterComponent>
    </>
  );
};

export default DonorReceiverFilter;
